module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Life Expectancy Calculator",
      "icon": "life-expectancy"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    ref: "gender",
    attrs: {
      "required": "",
      "name": "deceased_gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_gender')
    }
  }, [_vm._v("\n                    The deceased's gender is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_birth')
    }
  }, [_vm._v("\n                    The date of birth is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDob()
    }
  }, [_vm._v("\n                    The date of birth must be within 100 years of today\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfAssumedSettlement",
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("\n                    The date of assumed settlement is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDoAS()
    }
  }, [_vm._v("\n                    The date of assumed settlement must be within 100 years of today\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": 'Life Expectancy Type',
      "for": "method1"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lifeExpectancyMethod),
      expression: "lifeExpectancyMethod"
    }],
    ref: "lifeExpectancyMethod",
    attrs: {
      "id": "method1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lifeExpectancyMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ogden_table"
    }
  }, [_vm._v("Ogden Table 1/2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "years_and_months"
    }
  }, [_vm._v("Enter Years/Months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "enter_date"
    }
  }, [_vm._v("Enter Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "age_at_death"
    }
  }, [_vm._v("Enter Age At Death (years)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_of_normal_life_expectancy"
    }
  }, [_vm._v("% of Normal Life Expectancy")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "percentage_reduction_in_normal_life_expectancy"
    }
  }, [_vm._v("\n                        % Reduction in Normal Life Expectancy\n                    ")])])]), _vm._v(" "), (_vm.lifeExpectancyMethod == 'years_and_months') ? _c('control', {
    attrs: {
      "label": "Enter Years/Months From Today"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.years),
      expression: "years",
      modifiers: {
        "number": true
      }
    }],
    ref: "years",
    attrs: {
      "id": "years1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.years = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((76), function(year) {
    return _c('option', {
      domProps: {
        "value": year - 1
      }
    }, [_vm._v("\n                                " + _vm._s(year - 1) + " year" + _vm._s(year - 1 === 1 ? '' : 's') + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.months),
      expression: "months",
      modifiers: {
        "number": true
      }
    }],
    ref: "months",
    attrs: {
      "id": "months1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.months = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calcAgeAtDeath]
    }
  }, _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month - 1
      }
    }, [_vm._v("\n                                " + _vm._s(month - 1) + " month" + _vm._s(month - 1 === 1 ? '' : 's') + "\n                            ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_of_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage of Normal Life Expectancy",
      "for": "percentage_of_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageOfNormalLifeExpectancy),
      expression: "percentageOfNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "percentageOfNormalLifeExpectancy",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "max": "100",
      "min": "1",
      "disabled": _vm.lifeExpectancyMethod !== 'percentage_of_normal_life_expectancy',
      "name": "percentage_of_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageOfNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageOfNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_of_normal_life_expectancy')
    }
  }, [_vm._v("\n                    The percentage of normal life expectancy must be number between 1 and 100\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_reduction_in_normal_life_expectancy') ? _c('control', {
    attrs: {
      "label": "Percentage Reduction in Normal Life Expectancy",
      "for": "percentage_reduction_in_normal_life_expectancy",
      "before-after": "percent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.percentageReductionInNormalLifeExpectancy),
      expression: "percentageReductionInNormalLifeExpectancy",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    ref: "percentageReductionInNormalLifeExpectancy",
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.lifeExpectancyMethod !== 'percentage_reduction_in_normal_life_expectancy',
      "required": "",
      "max": "100",
      "min": "1",
      "name": "percentage_reduction_in_normal_life_expectancy",
      "type": "number"
    },
    domProps: {
      "value": (_vm.percentageReductionInNormalLifeExpectancy)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.percentageReductionInNormalLifeExpectancy = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('percentage_reduction_in_normal_life_expectancy')
    }
  }, [_vm._v("\n                    The percentage reduction in normal life expectancy must be number between 1 and 100\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod === 'enter_date') ? _c('control', {
    attrs: {
      "label": "Expected End of Life Date",
      "for": "date_of_death"
    }
  }, [_c('date-input', {
    ref: "dateOfDeathIsAssumed",
    on: {
      "input": _vm.calcAgeAtDeath
    },
    model: {
      value: (_vm.dateOfDeathIsAssumed),
      callback: function($$v) {
        _vm.dateOfDeathIsAssumed = $$v
      },
      expression: "dateOfDeathIsAssumed"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod === 'age_at_death') ? _c('control', {
    attrs: {
      "label": "Expected Age at End of Life (Years)",
      "for": "date_of_death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "ageAtDeath",
    attrs: {
      "autocomplete": "off",
      "min": "20",
      "name": "life_age_at_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), (_vm.lifeExpectancyMethod !== 'age_at_death') ? _c('control', {
    attrs: {
      "label": "Expected Age at End of Life (Years)",
      "for": "life_age_at_death",
      "modal-name": 'life_age_at_death_modal',
      "before-after": "years-old-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "min": "20",
      "disabled": "",
      "name": "life_age_at_death",
      "type": "number"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = _vm._n($event.target.value)
      }, _vm.calcAgeAtDeath],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lifeExpectancyMethod !== 'enter_date'),
      expression: "lifeExpectancyMethod!=='enter_date'"
    }],
    attrs: {
      "label": "Expected End of Life Date",
      "for": "date_of_death"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateOfDeath),
      expression: "dateOfDeath"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.dateOfDeath)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateOfDeath = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Age at today's date",
      "for": "age_today"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    domProps: {
      "value": this.ageToday()
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), (_vm.lifeExpectancyMethod == 'ogden_table' || _vm.lifeExpectancyMethod == 'percentage_of_normal_life_expectancy' || _vm.lifeExpectancyMethod == 'percentage_reduction_in_normal_life_expectancy') ? _c('div', [(_vm.lifeExpectancyMethod == 'ogden_table') ? _c('p', [_vm._v("\n                    Life expectancy has been calculated using gender and current age from the 0% discount column of Ogden Table 1 (for males) and Ogden Table 2 (for females)\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'ogden_table') ? _c('div', {
    staticClass: "a-table--really-wide"
  }, [(_vm.tableData) ? _c('table', {
    staticClass: "a-table a-table--miniCalc",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.tableData.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.tableData.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                    " + _vm._s(_vm.tableData.table.thead[0]) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                                " + _vm._s(column.value) + "\n                            ")])
    }), 0)
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tableData) ? _c('div', [_c('h2', [_vm._v("Calculation")]), _vm._v(" "), (Object.keys(_vm.tableData.table.tbody).length > 1) ? _c('div', [_c('p', [_vm._v("\n                                The person's age at today's date is " + _vm._s(_vm.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                                Therefore, interpolation between rows " + _vm._s(_vm.formulaData()[0]) + " and " + _vm._s(_vm.formulaData()[2]) + " is\n                                required on the 0% column to receive the projected mortality value:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_vm._v("\n                                    " + _vm._s(_vm.formulaData()[3]) + " + ((" + _vm._s(_vm.formulaData()[2]) + " - " + _vm._s(_vm.ageToday()) + ") x (" + _vm._s(_vm.formulaData()[1]) + " - " + _vm._s(_vm.formulaData()[3]) + ")) = " + _vm._s(_vm.result()) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                        Life expectancy is " + _vm._s(_vm.result()) + " years giving age at end of life of " + _vm._s(_vm.roundValue(_vm.ageAtDeath, 2)) + " years old.\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'years_and_months') ? _c('div', [_c('p', [_vm._v("\n                    The person's age at todays date is " + _vm._s(this.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the person being expected to live for another " + _vm._s(_vm.years) + " year(s) and " + _vm._s(_vm.months) + " month(s) they would be expected to live until the age of " + _vm._s(_vm.ageAtDeath) + " years old.\n                ")]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": [_vm.ageAtDeath, this.ageToday()]
    }
  }, [_c('h3', [_vm._v("Age at Expected Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(this.dateToday()))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'enter_date') ? _c('div', [_c('p', [_vm._v("\n                    The person's age at todays date is " + _vm._s(this.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the person being expected to live until the date of " + _vm._s(_vm.dateOfDeathIsAssumed) + " they would be expected to live until the age of " + _vm._s(_vm.ageAtDeath) + " years old.\n                ")]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": [_vm.ageAtDeath, this.ageToday()]
    }
  }, [_c('h3', [_vm._v("Age at Expected Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(this.dateToday()))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'age_at_death') ? _c('div', [_c('p', [_vm._v("\n                    The person's age at todays date is " + _vm._s(this.ageToday()) + " years old (DOB " + _vm._s(_vm.dateOfBirth) + ").\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the person being expected to live until the age of " + _vm._s(_vm.ageAtDeath) + " they would be expected to live until the date of " + _vm._s(_vm.dateOfDeathIsAssumed) + ".\n                ")]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": [_vm.ageAtDeath, this.ageToday()]
    }
  }, [_c('h3', [_vm._v("Age at Expected Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(this.dateToday()))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])])], 1) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_of_normal_life_expectancy') ? _c('div', [_c('p', [_vm._v("\n                    Based on gender and current age of " + _vm._s(this.ageToday()) + ", normal life expectancy using the 0% rate of return in Tables 1/2 of the Ogden Tables is " + _vm._s(_vm.ageAtDeath) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.percentageOfNormalLifeExpectancy) + "% of normal life expectancy would result in " + _vm._s(_vm.dateOfDeathIsAssumed) + " years remaining or an end of life date of " + _vm._s(_vm.dateOfDeath) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--really-wide"
  }, [(_vm.tableData) ? _c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.tableData.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.tableData.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                    " + _vm._s(_vm.tableData.table.thead[0]) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                                " + _vm._s(column.value) + "\n                            ")])
    }), 0)
  }), 0)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.lifeExpectancyMethod == 'percentage_reduction_in_normal_life_expectancy') ? _c('div', [_c('p', [_vm._v("\n                    Based on gender and current age of " + _vm._s(this.ageToday()) + ", reduction in normal life expectancy using the 0% rate of return in Tables 1/2 of the Ogden Tables is " + _vm._s(_vm.ageAtDeath) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.percentageReductionInNormalLifeExpectancy) + "% reduction of normal life expectancy would result in " + _vm._s(_vm.dateOfDeathIsAssumed) + " years remaining or an end of life date of " + _vm._s(_vm.dateOfDeath) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--really-wide"
  }, [(_vm.tableData) ? _c('table', {
    staticClass: "a-table a-table--modal",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [(_vm.tableData.table.thead[0].length) ? _c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.tableData.table.thead[1].length
    }
  }, [_c('div', {
    staticClass: "u-text-center"
  }, [_vm._v("\n                                    " + _vm._s(_vm.tableData.table.thead[0]) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.tableData.table.thead[1]), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', {
        class: {
          'a-table--highlight': column.highlight
        }
      }, [_vm._v("\n                                " + _vm._s(column.value) + "\n                            ")])
    }), 0)
  }), 0)]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9383c0f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/lifeExpectancy.vue
// module id = 1775
// module chunks = 0